import createReducer from "../../createReducer";
import { googleSheetsConfigHandlers } from "../handlers";
import { IGoogleSheetsState } from "../types";

export const updateGoogleSheetsConfig: IGoogleSheetsState = {
    isLoading: false,
    error: null,
    config: null,
};

export default createReducer(updateGoogleSheetsConfig, googleSheetsConfigHandlers);
